module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GAZ94M/tc-custom/9781504073219.jpg?1737674837846",
      "alt": "This image is the cover for the book Kindness of Strangers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kindness of Strangers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This novel about the dark past that haunts a seemingly happy household is “an intricate portrayal of love and loss, redemption and revenge” (Anne Coates, author of "), _c('i', [_vm._v("Songs of Innocence")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Helen, a widow, is desperate for a perfect family life and will do everything she can to get what she wants."), _c('br'), _c('br'), _vm._v("Martin, a veteran, is adrift and seemingly without hope. Can he ever win back his estranged family?"), _c('br'), _c('br'), _vm._v("Charley, a pregnant teenager, is striking out on her own to create a new life for her unborn child—but her mother has other ideas."), _c('br'), _c('br'), _vm._v("When these three seemingly disparate lives connect, the past and the present collide to reveal secrets, lies, and just how far people are willing to go to hide the truth . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Newman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0